import { render, staticRenderFns } from "./HotSticks.vue?vue&type=template&id=6f5dd666&scoped=true"
import script from "./HotSticks.vue?vue&type=script&lang=js"
export * from "./HotSticks.vue?vue&type=script&lang=js"
import style0 from "./HotSticks.vue?vue&type=style&index=0&id=6f5dd666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5dd666",
  null
  
)

export default component.exports